{
  "credits": {
    "ledger": {
      "signupGift": "Sign-up gift",
      "topUp": "Top-up of {{amount}} {{coin}}",
      "storePurchase": "Purchase of {{amount}} {{coin}} from {{store}}",
      "giftCode": "Gift code {{code}}",
      "prize": "Prize wheel reward",
      "gift": "Gift credit",
      "stores": {
        "bazaar": "Cafe Bazaar"
      }
    }
  }
}
